import { colorForHour, isDarkHour } from "../color";
import { db, cityName } from "../tz";
import { formatDate, formatOffset, formatTime, toCivil, type TimeFormat } from "../tz/civil";

interface Props {
  instant: number;
  sourceDay: string;
  zones: string[];
  fmt: TimeFormat;
  onRemove: (id: string) => void;
  onClear: () => void;
  onReference: (id: string) => void;
}

export function Watched({ instant, sourceDay, zones, fmt, onRemove, onClear, onReference }: Props) {
  if (zones.length === 0) {
    return <p class="watch-empty muted">Click places on the map to see this moment on their clocks.</p>;
  }
  return (
    <section class="watch">
      <div class="watch-head">
        <h2>On other clocks</h2>
        <button type="button" class="btn small" onClick={onClear}>Clear all</button>
      </div>
      <div class="watch-grid">
        {zones.map((id) => {
          const z = db.zone(id);
          const t = z.typeAt(instant);
          const local = toCivil(instant + t.utoff);
          const day = `${local.year}-${String(local.month).padStart(2, "0")}-${String(local.day).padStart(2, "0")}`;
          const dayDiff = day === sourceDay ? "" : day > sourceDay ? "+1 day" : "−1 day";
          const h = local.hour + local.minute / 60;
          const next = z.nextTransition(instant);
          return (
            <div key={id} class={`watch-card${isDarkHour(h) ? " dark" : " light"}`} style={{ background: colorForHour(h) }}>
              <button type="button" class="watch-remove" title="Remove" aria-label={`Remove ${cityName(id)}`} onClick={() => onRemove(id)}>×</button>
              <div class="watch-city">
                {cityName(id)} <span class="watch-id">{id}</span>
              </div>
              <div class="watch-time">
                {formatTime(local, fmt)}
                {dayDiff && <span class="watch-day">{dayDiff}</span>}
              </div>
              <div class="watch-meta">
                {formatDate(local)} · {t.abbr} · UTC{formatOffset(t.utoff)}{t.isdst ? " · daylight time" : ""}
              </div>
              {next && (
                <div class="watch-meta">
                  Clocks change {formatDate(toCivil(next.at + next.before.utoff))} ({next.before.abbr} → {next.after.abbr})
                </div>
              )}
              <button type="button" class="watch-ref" onClick={() => onReference(id)}>use as reference</button>
            </div>
          );
        })}
      </div>
    </section>
  );
}
